document.addEventListener('findstrLoaded', () => {
  const findstr = window.findstr || {};

  if (typeof findstr.hooks === 'undefined') {
    return;
  }

  // The plugin's searchResults handler (priority 10) only checks filter changes,
  // not the search query — so it leaves the reset button disabled when only the
  // search field has a value. This handler runs after (priority 20) and re-enables
  // the button when the search input is non-empty.
  findstr.hooks.addAction(
    'searchResults',
    'olhi-oap',
    function (results, group) {
      const searchInputs = document.querySelectorAll(
        `.findstr-field-search input[type="search"][data-findstr-group="${group}"]`
      );

      const hasSearchValue = Array.from(searchInputs).some(
        (input) => input.value.trim() !== ''
      );

      if (!hasSearchValue) {
        return;
      }

      document
        .querySelectorAll(
          `.findstr-field.findstr-field-reset[data-group="${group}"] .resetFilters`
        )
        .forEach((btn) => {
          btn.disabled = false;
        });
    },
    20
  );
});
